module.exports = "/build/web/images/review-image-4.1e06495a7ab6c63f8cb7540628d9f3d2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./images/review-image-4.jpeg
// module id = 134
// module chunks = 11